// extracted by mini-css-extract-plugin
export var card = "featured-module--card--bbb64";
export var center = "featured-module--center--4433b";
export var textDecorationNone = "featured-module--textDecorationNone--19c55";